import React, { useState } from "react";
import { Auth } from "aws-amplify";
import { useNavigate } from "react-router"
import {
  Flex,
} from "@chakra-ui/react";
import { NewPassword } from "../../components/NewPassword";
import { SignIn } from "../../components/SignIn";
import {
  validateEmail,
  validatePhone,
  validatePassword,
} from "../../utils/helper";

export const SignInPage = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [countryCode, setCountryCode] = useState("+91");
  const [user, setUser] = useState(null);
  const [newPassword, setNewPassword] = useState("");
  const [newPasswordAgain, setNewPasswordAgain] = useState("");
  const [isPasswordError, setIsPasswordError] = useState(false);
  const [isRepeatPasswordError, setIsRepeatPasswordError] = useState(false);
  const [isNewPasswordRequired, setIsNewPasswordRequired] = useState(false);
  const [showCountryCode, setShowCountryCode] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [signinErrorMessage, setSigninErrorMessage] = useState("");
  const [isError, setIsError] = useState(false);
  const [isSigninError, setIsSigninError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const onUserNameChange = (e) => {
    setUsername(e.target.value);
    if (isNaN(e.target.value) || e.target.value === "") {
      setShowCountryCode(false);
    } else {
      setShowCountryCode(true);
    }
    if (isNaN(e.target.value) && !validateEmail(e.target.value)) {
      setIsError(true);
      setErrorMessage("Enter a valid email");
    } else if (!isNaN(e.target.value) && !validatePhone(e.target.value)) {
      setIsError(true);
      setErrorMessage("Enter a valid phone number");
    } else {
      setIsError(false);
      setErrorMessage("");
    }
  };
  const onPasswordChange = (e) => {
    if (e.target.name === "new_password") {
      setNewPassword(e.target.value);
      if (!validatePassword(e.target.value)) {
        setIsPasswordError(true);
      } else {
        setIsPasswordError(false);
      }
    }
    if (e.target.name === "new_password_again") {
      setNewPasswordAgain(e.target.value);
      if (
        !validatePassword(e.target.value) ||
        newPassword.trim() !== e.target.value
      ) {
        setIsRepeatPasswordError(true);
      } else {
        setIsRepeatPasswordError(false);
      }
    }
  };
  const signIn = async (e) => {
    e.preventDefault();
    if (isNaN(username) && !validateEmail(username)) {
      setIsError(true);
      setErrorMessage("Enter a valid email");
      return true;
    }
    if (!isNaN(username) && !validatePhone(username)) {
      setIsError(true);
      setErrorMessage("Enter a valid phone number");
      return true;
    }
    const userName = isNaN(username) ? username : `${countryCode}${username}`;
    try {
      setIsLoading(true);
      const user = await Auth.signIn(userName, password);
      setIsLoading(false);
      if (user.challengeName === "NEW_PASSWORD_REQUIRED") {
        setUser(user);
        setIsNewPasswordRequired(true);
      } else {
        navigate("/");
      }
    } catch (err) {
      if (err.code === 'UserNotConfirmedException') {
        setIsSigninError(true);
        setSigninErrorMessage('Your email is not confirmed. Please verify your email.');
        navigate(`/confirm-signup/${userName}`)
      } else {
        setIsLoading(false);
        setIsSigninError(true);
        setSigninErrorMessage(err.message || 'An error occurred. Please try again.');
      }
    }
  };
  const onNewPasswordSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      // eslint-disable-next-line no-unused-vars
      const response = await Auth.completeNewPassword(user, newPassword, {
        given_name: user?.challengeParam?.userAttributes?.given_name,
        family_name: user?.challengeParam?.userAttributes?.family_name,
      });
      setIsLoading(false);
      navigate("/");
    } catch (err) {
      setIsLoading(false);
      setIsSigninError(true);
      setSigninErrorMessage(err.message);
    }
  };
  return (
    <Flex
      sx={{
        minHeight: "100vh",
        alignItems: {base: "flex-start", sm: "center"},
        justifyContent: {base: "flex-start", sm: "center"},
        padding: "20px",
        background: "rgb(249 250 251)"
      }}
    >
      {isNewPasswordRequired ? (
        <NewPassword
          newPassword={newPassword}
          newPasswordAgain={newPasswordAgain}
          isPasswordError={isPasswordError}
          isRepeatPasswordError={isRepeatPasswordError}
          isLoading={isLoading}
          onPasswordChange={onPasswordChange}
          onNewPasswordSubmit={onNewPasswordSubmit}
          showPassword={showNewPassword}
          toggleShowPassword={() => setShowNewPassword(!showNewPassword)}
        />
      ) : (
        <SignIn
          username={username}
          password={password}
          errorMessage={errorMessage}
          signinErrorMessage={signinErrorMessage}
          isSigninError={isSigninError}
          showCountryCode={showCountryCode}
          isError={isError}
          isLoading={isLoading}
          onUserNameChange={onUserNameChange}
          onPasswordChange={(e) => setPassword(e.target.value)}
          showPassword={showPassword}
          toggleShowPassword={() => setShowPassword(!showPassword)}
          codeChange={(country_code) => setCountryCode(country_code)}
          signIn={signIn}
        />
      )}
    </Flex>
  );
}